import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react'

interface UseIsManualModeContext {
  beManualMode: Dispatch<SetStateAction<boolean>>
  isManualMode: boolean
}

interface IsManualModeProviderProps {
  children: ReactNode
}

const context = createContext({ isManualMode: false } as UseIsManualModeContext)
const { Provider } = context

const IsManualModeProvider = ({ children }: IsManualModeProviderProps) => {
  const [isManualMode, beManualMode] = useState(false)

  const contextValue = {
    beManualMode,
    isManualMode,
  }

  return <Provider value={contextValue}>{children}</Provider>
}

const useIsManualMode = () => useContext(context)

export { IsManualModeProvider, useIsManualMode }
